import React from 'react';
import './LeaderboardSciFiPanel.css';

interface LeaderboardSciFiPanelProps {
  title?: string;
  onClose: () => void;
  children: React.ReactNode;
}

const LeaderboardSciFiPanel: React.FC<LeaderboardSciFiPanelProps> = ({ title = 'GALACTIC LEADERBOARD', onClose, children }) => {
  return (
    <div className="scifi-leaderboard-overlay">
      <div className="scifi-leaderboard-panel">
        <div className="scifi-leaderboard-header">
          <span className="scifi-leaderboard-title">{title}</span>
          <button className="scifi-leaderboard-close" onClick={onClose} title="Close">✕</button>
        </div>
        <div className="scifi-leaderboard-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default LeaderboardSciFiPanel;
